import React from "react";
import Lottie from "lottie-react";
import BlackLogoAnimation from "../../assets/BlackLogoAnimation.json";
import { View } from "react-native";
import LoadingBoldWhite from "../../assets/LoadingBoldWhite.json";
import LoadingBold from "../../assets/LoadingBold.json";

const CustomActivityIndicator = React.memo(
  ({ marginTop, large = true, white = false }) => {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          marginTop: marginTop || 0,
        }}
      >
        {large ? (
          <Lottie
            animationData={BlackLogoAnimation}
            loop
            style={{ maxWidth: 90 }}
          />
        ) : (
          <Lottie
            animationData={white ? LoadingBoldWhite : LoadingBold}
            loop
            style={{ maxWidth: 18 }}
          />
        )}
      </View>
    );
  }
);

export default CustomActivityIndicator;
